import type { FaireProductEntity } from "../../entity_types/product";

export const p_vjq7z5y2su: FaireProductEntity = {
  token: "p_vjq7z5y2su",
  type: "product",
  name: "Devil's Eye Pendant Blue Eye Handmade Cotton Thread Tapestry",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/5f701e4414d266ca62a0e19e40b9ba38af1c86e30f6e54fd4776f5ae268b6d5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/037b06bc4d1f5a6057cc6bae9051548e798744460bfd79d469e26ab1adb0a2c1.jpeg",
    "https://cdn.faire.com/fastly/df42f0a71dbbbbf1b0d8f9e692aa3a7418031a259715bab7a925957fe7a115fe.jpeg",
    "https://cdn.faire.com/fastly/cd94e89bae12d6c7cda9971509f6f0b7d8436e2e33db024dea01e5ed921517e0.jpeg",
    "https://cdn.faire.com/fastly/a8b89dca312dc1884634c2f98144fe0c0d43e260f76aa2503343c588033689d9.jpeg",
    "https://cdn.faire.com/fastly/5d96af556e8828795c851491468ad5f741ffd788fa99ddc6bd312be67aa0a3b5.jpeg",
  ],
  priceDollars: 11.06,
  description:
    "*Handicrafts, there may be a 1-2cm error, thank you for your understanding\n\nImmerse yourself in mystique with our Devil's Eye Pendant featuring Blue Eyes and a Handmade Cotton Thread Woven Tapestry. This unique accessory seamlessly blends artistic craftsmanship with an enigmatic touch. The woven tapestry adds a bohemian flair, creating a statement piece that captivates with its intricate design. Embrace the extraordinary.\n\nADORABLE & TRENDY! Offer many hours of enjoyment for Store！💜\n🎄💗\nHow cute are these Items! These make GREAT gifts💝! \n🎀Gift Idea | Gifts Store\n\n❤️ Thank you so much for love & support ❤️\n\n•✈️ After your order is placed, we ship in 7 - 9 business days.✈️\n•❤️ All shipping comes with Tracking Numbers.🧡\n\n💌 However, your satisfaction is our first priority so please feel free to contact us if you have any question about your order.\n\n**Please note these items are Manual Measurement, Measurements are approximate.\n**Any props seen in photo are not available for sale.",
  tags: [],
  msrpDollars: 22.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:28.408Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
